// api.openweathermap.org/data/2.5/weather?q=Ambala&units=metric&APPID=53b61b3ff7af4e40df6e77189c40ac41

import React, { useState, useEffect } from 'react';
import Weathercard from './weathercard';
import "./style.css";

const Temp = () => {
    const [searchValue, setSearchValue] = useState("Ambala");
    const [tempInfo, setTempInfo] = useState({});

    const getWeatherInfo = async () => {
        try {
            let url = `https://api.openweathermap.org/data/2.5/weather?q=${searchValue}&units=metric&appid=53b61b3ff7af4e40df6e77189c40ac41`;

            const res = await fetch(url);
            const data = await res.json();

            const { temp, humidity, pressure, feels_like } = data.main;
            const { main: weathermood } = data.weather[0];
            const { name } = data;
            const { speed } = data.wind;
            const { country} = data.sys

            const myNewWeatherInfo = {
                temp, humidity, pressure,feels_like,weathermood, name, speed, country
            };

            setTempInfo(myNewWeatherInfo);


        } catch (error) {
            console.log(error);
        }

    };

    useEffect(() => {
        getWeatherInfo();
    }, [])

    return (
        <>

            <div className='wrap'>
                <div className='search'>
                    <input type="search"
                        placeholder='search...'
                        autoFocus
                        id="search"
                        className="searchTerm"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                    />

                    <button className="searchButton" type='button' onClick={getWeatherInfo}>
                        Search
                    </button>

                </div>
            </div>

            {/* our Temp Card */}

            <Weathercard tempInfo={tempInfo}/>

            

        </>
    );
};

export default Temp